<svg
  xmlns="http://www.w3.org/2000/svg"
  style="display: none"
  height="5"
  width="5"
>
  <symbol id="circle" viewbox="0 0 5 5">
    <circle cx="2.5" cy="2.5" r="2" fill="#879baf" />
  </symbol>
</svg>

<div class="set-time">SET TIME</div>
<div class="time-parts">
  <evrideo-time-slice
    [isHour]="true"
    [timeSlice]="hours"
    (valueChanged)="updateTime($event, 'h')"
  ></evrideo-time-slice>
  <div class="divider">
    <svg><use xlink:href="#circle" /></svg>
    <svg><use xlink:href="#circle" /></svg>
  </div>
  <evrideo-time-slice
    [timeSlice]="minutes"
    (valueChanged)="updateTime($event, 'm')"
  ></evrideo-time-slice>
</div>
